import { __spreadArrays } from "tslib";
import * as _ from 'lodash';
import { FormsFieldPreset } from '../constants';
import { CURRENCIES } from './currencies';
export var getCurrencyByKey = function (currencyKey) { return CURRENCIES[currencyKey]; };
export var paymentMappingToRadioOptions = function (paymentItemsMapping, currency, _a) {
    var t = _a.t;
    return _.reduce(paymentItemsMapping, function (acc, currentValue, currentKey) { return __spreadArrays(acc, [
        {
            label: t("fieldTypes." + FormsFieldPreset.GENERAL_ITEMS_LIST + ".itemName", {
                currency: getCurrencyByKey(currency).symbol,
                name: currentValue.label,
                price: currentValue.price,
            }),
            value: currentKey,
        },
    ]); }, []);
};
//# sourceMappingURL=helpers.js.map